export default __webpack_public_path__ + "static/media/webinar-upcoming.4ce7f771.jpg";